import type {
  AircallMonitorCreateOptions,
  AircallMonitorInstance,
} from "./widget.ts";
import { createWidget } from "./widget.ts";

export type { AircallMonitorCreateOptions, AircallMonitorInstance };

/** Contrato embebido: `window.AircallMonitor.create({ ... })`. Sin exports de runtime extra (el IIFE debe ser un solo objeto). */
const AircallMonitor = {
  create(options: AircallMonitorCreateOptions): AircallMonitorInstance {
    return createWidget(options);
  },
};

export default AircallMonitor;
